import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "index" }
const _hoisted_2 = { class: "banner-container" }

import { ref } from 'vue';
import Banner from '@/components/web/Banner.vue';
import IndexService from '@/components/web/IndexService.vue';
import { useIndexMeta } from '@/composables/useIndexMeta';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

useIndexMeta();

const bannerImages = ref([{
  imgUrl: "https://www.graycasting.com/uploads/views/index/banner-!j.webp",
  alt: "Die Casting China"
}]);

const BannerHeight = ref(550);
const isHovered = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Banner, {
        bannerImages: bannerImages.value,
        hover: isHovered.value,
        BannerHeight: BannerHeight.value
      }, null, 8, ["bannerImages", "hover", "BannerHeight"])
    ]),
    _createVNode(IndexService)
  ]))
}
}

})